import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThreats = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.00006 0L9.25113 0.0891947L17.261 2.93475L17.7599 3.11199V3.64147V8.8003C17.7599 9.79544 17.6409 10.787 17.4055 11.7539C16.8883 13.8786 15.5788 15.7255 13.7449 16.9166L9.40858 19.7331L9.00006 19.9984L8.59153 19.7331L4.25525 16.9166C2.42135 15.7255 1.11184 13.8786 0.594585 11.7539C0.359195 10.787 0.240234 9.79544 0.240234 8.8003V3.64147V3.11199L0.739164 2.93475L8.74899 0.0891947L9.00006 0ZM1.74023 4.17095V8.8003C1.74023 9.6759 1.8449 10.5484 2.05202 11.3991C2.47879 13.1521 3.55922 14.6759 5.0723 15.6587L9.00006 18.2098L12.9278 15.6587C14.4409 14.6759 15.5213 13.1521 15.9481 11.3991C16.1552 10.5484 16.2599 9.6759 16.2599 8.8003V4.17095L9.00006 1.59184L1.74023 4.17095ZM8.24998 9.76814V5.08708H9.74998V9.76814H8.24998ZM9.0001 13.6688C9.63206 13.6688 10.1444 13.1449 10.1444 12.4986C10.1444 11.8523 9.63206 11.3283 9.0001 11.3283C8.36814 11.3283 7.85584 11.8523 7.85584 12.4986C7.85584 13.1449 8.36814 13.6688 9.0001 13.6688Z",
		fill: "#90919C"
	})
});
export default SvgThreats;
